import React from 'react';
import { track, checkDay7Return } from './analytics';
import { setupGlobalErrorHandlers } from './logger';
import ReactDOM from 'react-dom/client';
import App from './App';
import { PrivacyPage, TermsPage } from './Legal';
import { LandingPage } from './Landing';

// ── AUTO-UPDATE ON iOS PWA ──────────────────────────────────
const BUILD_VERSION = process.env.REACT_APP_VERSION || "dev";
const STORED_KEY = "bb_build_v";

function checkForUpdate() {
  try {
    if (BUILD_VERSION === "dev") return;
    const stored = localStorage.getItem(STORED_KEY);
    if (!stored) { localStorage.setItem(STORED_KEY, BUILD_VERSION); return; }
    if (stored !== BUILD_VERSION) {
      localStorage.setItem(STORED_KEY, BUILD_VERSION);
      setTimeout(() => window.location.reload(true), 80);
    }
  } catch(e) {}
}

checkForUpdate();

// Global error handlers — must run before React mounts
setupGlobalErrorHandlers();

// app_open — once per page load, window guard prevents StrictMode double-fire
if (!window.__bb_tracked_open) {
  window.__bb_tracked_open = true;
  track('app_open');
  checkDay7Return();
}

const path = window.location.pathname;
const root = ReactDOM.createRoot(document.getElementById('root'));

if (path === "/privacy" || path === "/privacy/") {
  root.render(<PrivacyPage />);
} else if (path === "/terms" || path === "/terms/") {
  root.render(<TermsPage />);
} else if (path === "/home" || path === "/home/") {
  root.render(<LandingPage />);
} else {
  root.render(<App />);
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}